import { Box } from '@chakra-ui/react';
import { useGetExistingSurvey, useSubmitSurvey } from '@components/crm/shared/queries';
import Spinner from '@components/icons/Spinner';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import NegativeSurveyResult from './NegativeSurveyResult';
import PositiveSurveyResult from './PositiveSurveyResult';

const PlanSatisfactionSurvey = () => {
  const [submitted, setSubmitted] = useState(false);
  const router = useRouter();
  const { id, response } = router.query;
  const surveyResponse = response === 'true';
  const { data, isFetched } = useGetExistingSurvey({
    userId: id,
  });
  const [latestComment, setLatestComment] = useState('');
  const { mutateAsync: submitSurveyMutation, error } = useSubmitSurvey({
    userId: id,
    response,
    userComment: latestComment,
  });

  const handleSubmit = (comment) => {
    setLatestComment(comment);
    submitSurveyMutation();
    setSubmitted(true);
  };

  useEffect(() => {
    if (id && response && isFetched) {
      if (data?.userComment) {
        setLatestComment(data.userComment);
      }
      submitSurveyMutation();
    }
  }, [id, response, data, isFetched]);

  if (!id || !response || !isFetched) {
    return <Spinner />;
  }

  if (error) {
    return null;
  }

  return (
    <Box pt="2 rem">
      {surveyResponse ? (
        <PositiveSurveyResult userId={id} />
      ) : (
        <NegativeSurveyResult
          submitSurvey={handleSubmit}
          userComment={latestComment}
          submitted={submitted}
          setSubmitted={setSubmitted}
        />
      )}
    </Box>
  );
};

export default PlanSatisfactionSurvey;
